// Translations dictionary for English / Arabic.
// To update copy, edit the strings below. Keep keys identical between en and ar.
export const translations = {
  en: {
    meta: {
      siteName: "ELITE AL HIJAZ Est.",
      arabicName: "مؤسسة نخبة الحجاز للمقاولات",
      tagline: "Steel Fabrication & General Contracting",
    },
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      projects: "Projects",
      clients: "Clients",
      manpower: "Manpower",
      contact: "Contact",
      switchLang: "العربية",
      menu: "Menu",
    },
    hero: {
      overline: "Engineering & Contracting · Saudi Arabia",
      title: "Engineering & Contracting Excellence Across Saudi Arabia",
      subtitle:
        "Integrated industrial solutions in electro-mechanical works, steel fabrication, heavy erections, automation systems, and maintenance.",
      ctaPrimary: "Explore Services",
      ctaSecondary: "Contact Us",
      scroll: "Scroll",
    },
    homeSections: {
      s1Overline: "Built for Industrial Excellence",
      s1Title: "Reliability, Precision, Saudi Industrial Experience",
      s1Body:
        "Elite Al Hijaz delivers end-to-end technical solutions engineered for factories, plants and infrastructure across the Kingdom. Innovation and discipline define every project.",
      s2Overline: "From Fabrication to Automation",
      s2Title: "A Continuous Industrial Capability",
      s2Body:
        "We move seamlessly from heavy steel fabrication and erection to PLC, control panels and full automation lines — one accountable partner across the value chain.",
      s3Overline: "Reliable Partner for Industrial Projects",
      s3Title: "Trusted by Leading Brands",
      s3Body:
        "Industrial leaders choose us for technical depth, safety culture and disciplined delivery.",
      stats: {
        years: "Years of Engineering",
        regions: "Regions Across KSA",
        manpower: "Skilled Manpower",
        services: "Industrial Capabilities",
      },
    },
    about: {
      overline: "About Elite Al Hijaz",
      title: "Engineering & Contracting Excellence Across Saudi Arabia",
      p1: "Elite Al Hijaz Est. is a leading engineering and contracting establishment based in Saudi Arabia, delivering comprehensive end-to-end technical solutions for industrial and commercial sectors. With a strong foundation in innovation, reliability, and precision, the company provides integrated services tailored to the evolving needs of factories, plants, infrastructure developments, and large-scale industrial facilities across the Kingdom.",
      p2: "With over 15 years of engineering excellence across different regions of Saudi Arabia, Elite Al Hijaz has built a strong track record through large-scale and small-scale partnerships. The company is committed to quality, safety, customer satisfaction, and long-term project value.",
      values: [
        { t: "Innovation", d: "Modern engineering practices and continuous improvement on every site." },
        { t: "Reliability", d: "Disciplined execution, on-time delivery and dependable partnerships." },
        { t: "Precision", d: "Tight tolerances, quality control and verified workmanship." },
        { t: "Safety", d: "Zero-harm culture with PPE discipline and site-specific safety plans." },
      ],
    },
    services: {
      overline: "Our Services",
      title: "Integrated Industrial Capabilities",
      subtitle:
        "Four core service lines covering the full lifecycle of industrial projects — from contract to commissioning to maintenance.",
      cards: [
        {
          t: "Electro Mechanical General Contracting",
          d: "Complete electro-mechanical contracting solutions for industrial and commercial facilities, including installation, integration, commissioning, and technical support.",
        },
        {
          t: "Steel Fabrication & Heavy Erection Works",
          d: "Professional fabrication and erection of industrial steel structures, tanks, silos, conveyors, heavy equipment, platforms, and plant-related structures.",
        },
        {
          t: "Automation & Control Systems",
          d: "Industrial automation solutions including control panels, PLC-related systems, production line support, mobile bagging units, bag closing machines, magnetic de-stoners, hump magnets, distribution boards, and MCC control panels.",
        },
        {
          t: "Maintenance",
          d: "Reliable maintenance and repair solutions for industrial machinery, conveyors, shafts, blowers, rubber belts, concrete repair, gasket systems, retaining compounds, and heavy equipment reliability.",
        },
      ],
      capOverline: "Capabilities",
      capTitle: "Mechanical Fabrication Capabilities",
      capSubtitle:
        "A complete in-house workshop covering structural, mechanical and process equipment.",
      capItems: [
        "Cyclones",
        "Hoppers",
        "Tanks & Silos",
        "Jaw Crushers",
        "Bucket Elevators",
        "Machine Shop Work",
        "Platform Structure",
        "Mixer and Stirrer Systems",
        "Double Disperser Blades for Mixers",
        "CNC Waterjet and Plasma Cutting",
        "Belt Conveyors",
        "Screw Conveyors",
        "Modular Chain Conveyors",
        "Trolley Systems",
        "Blades and Cutters",
        "Tables",
        "Fans & Blowers",
        "Shafts and Housing",
        "Dust Collectors",
      ],
    },
    projects: {
      overline: "Selected Work",
      title: "Industrial Projects Portfolio",
      subtitle:
        "From mechanical fabrication to large-scale erection and automation — a snapshot of recent work.",
      filters: {
        all: "All",
        fabrication: "Fabrication",
        erection: "Erection",
        automation: "Automation",
        maintenance: "Maintenance",
      },
      viewDetails: "View Details",
      categories: {
        fabrication: "Mechanical Fabrication",
        erection: "Heavy Erection Works",
        automation: "Automation Systems",
        maintenance: "Maintenance Works",
        bagging: "Mobile Bagging Unit Manufacturing",
        installation: "Industrial Equipment Installation",
      },
      items: [
        { cat: "fabrication", title: "Mechanical Fabrication", desc: "Fabrication of tanks, silos, platforms, conveyors, and industrial structures with precision engineering." },
        { cat: "erection", title: "Heavy Erection Works", desc: "Safe and efficient heavy erection support for industrial plants, steel structures, and heavy equipment." },
        { cat: "automation", title: "Automation Systems", desc: "Control panels, automation support, production machinery integration, and industrial system optimization." },
        { cat: "maintenance", title: "Maintenance", desc: "Repair, rebuilding, industrial leakage solutions, rubber belt repair, machinery overhaul, and preventive support." },
        { cat: "fabrication", title: "Mobile Bagging Unit", desc: "End-to-end manufacturing of mobile bagging units integrated with bag closing machines." },
        { cat: "automation", title: "MCC & Distribution Boards", desc: "Custom MCC control panels, distribution boards and PLC-driven production line panels." },
        { cat: "erection", title: "Silo & Tank Erection", desc: "Erection of silos, tanks and process vessels for cement, food and chemical sectors." },
        { cat: "maintenance", title: "Conveyor Overhaul", desc: "Belt conveyor rebuild, rubber belt vulcanizing, shaft alignment and bearing replacement." },
      ],
    },
    clients: {
      overline: "Our Clients",
      title: "Our Trusted Clients",
      subtitle: "Proud to support leading industrial and commercial brands.",
      list: [
        "Jotun",
        "B Pharma",
        "Abdul Latif Jameel",
        "CEEER",
        "Unilever",
        "Nesma Orbit",
        "Hill's Metal Roofing",
        "NBCC",
        "RC Cola",
        "UCIC",
        "Fosroc",
        "Euro Design Build",
      ],
    },
    manpower: {
      overline: "Strength",
      title: "Manpower & Safety Strength",
      subtitle:
        "A multi-disciplinary team built around mechanical, electrical, fabrication and safety expertise.",
      stats: [
        { label: "Mechanical Engineers", value: 2 },
        { label: "Electrical Engineer", value: 1 },
        { label: "Steel Fabricators", value: 4 },
        { label: "Welders", value: 8 },
        { label: "MIG Welders", value: 2 },
        { label: "TIG Welders", value: 3 },
        { label: "Mechanics", value: 6 },
        { label: "Riggers", value: 10 },
        { label: "Fitters", value: 8 },
        { label: "Labours", value: 20 },
        { label: "Supervisors", value: 2 },
      ],
      safetyOverline: "Safety",
      safetyTitle: "Safety First",
      safetyBody:
        "Safety is a core value in every Elite Al Hijaz project. Our teams follow professional safety standards, use proper PPE, and maintain disciplined site execution to protect workers, clients, and project assets.",
      safetyChecks: [
        "Site-specific safety plans on every project",
        "Mandatory PPE: helmet, goggles, harness, gloves",
        "Toolbox talks and daily HSE briefings",
        "Permit-to-work system for hot works and confined spaces",
        "Documented risk assessments and method statements",
      ],
    },
    contact: {
      overline: "Contact",
      title: "Contact Elite Al Hijaz",
      subtitle: "Tell us about your project. Our engineering team will respond promptly.",
      form: {
        name: "Full Name",
        company: "Company Name",
        email: "Email Address",
        phone: "Phone Number",
        service: "Service Required",
        servicePlaceholder: "Select a service",
        message: "Project Details / Message",
        submit: "Send via WhatsApp",
        submitEmail: "Send via Email",
        success: "Opening WhatsApp with your message…",
      },
      servicesList: [
        "Electro Mechanical General Contracting",
        "Steel Fabrication & Heavy Erection",
        "Automation & Control Systems",
        "Industrial Maintenance",
        "Other",
      ],
      info: {
        company: "Company",
        cr: "CR",
        vat: "VAT",
        phone: "Phone",
        email: "Email",
        address: "Address",
        addressValue: "Wadi Al Qaim Street, Al Aziziyah Dist, Jeddah 23337, Kingdom of Saudi Arabia",
        website: "Website",
      },
      callNow: "Call Now",
      whatsapp: "WhatsApp",
      emailUs: "Email Us",
    },
    footer: {
      tagline: "Engineering & Contracting Excellence Across Saudi Arabia",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      copyright: "© {year} Elite Al Hijaz Est. All rights reserved.",
    },
    common: {
      loading: "Loading",
      backToTop: "Back to top",
      learnMore: "Learn More",
    },
  },

  ar: {
    meta: {
      siteName: "مؤسسة نخبة الحجاز للمقاولات",
      arabicName: "مؤسسة نخبة الحجاز للمقاولات",
      tagline: "تصنيع الحديد والمقاولات العامة",
    },
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "الخدمات",
      projects: "المشاريع",
      clients: "العملاء",
      manpower: "الكوادر والسلامة",
      contact: "تواصل معنا",
      switchLang: "English",
      menu: "القائمة",
    },
    hero: {
      overline: "هندسة ومقاولات · المملكة العربية السعودية",
      title: "تميّز هندسي ومقاولات على مستوى المملكة",
      subtitle:
        "حلول صناعية متكاملة تشمل الأعمال الكهروميكانيكية وتصنيع الحديد والتركيبات الثقيلة وأنظمة الأتمتة والصيانة.",
      ctaPrimary: "استكشف الخدمات",
      ctaSecondary: "تواصل معنا",
      scroll: "اسحب للأسفل",
    },
    homeSections: {
      s1Overline: "صُممت للتميّز الصناعي",
      s1Title: "موثوقية ودقة وخبرة صناعية سعودية",
      s1Body:
        "تقدّم نخبة الحجاز حلولاً تقنية متكاملة مصممة للمصانع والمنشآت والبنية التحتية في جميع أنحاء المملكة. الابتكار والانضباط هما ركيزتا كل مشروع.",
      s2Overline: "من التصنيع إلى الأتمتة",
      s2Title: "قدرة صناعية متواصلة",
      s2Body:
        "ننتقل بسلاسة من تصنيع الحديد الثقيل والتركيب إلى لوحات التحكم وأنظمة PLC وخطوط الأتمتة الكاملة — شريك واحد مسؤول عن كامل سلسلة القيمة.",
      s3Overline: "شريك موثوق للمشاريع الصناعية",
      s3Title: "ثقة كبرى العلامات التجارية",
      s3Body: "تختارنا كبرى الشركات الصناعية لعمقنا التقني وثقافة السلامة والتسليم المنضبط.",
      stats: {
        years: "سنوات من الهندسة",
        regions: "مناطق في المملكة",
        manpower: "كوادر مهرة",
        services: "قدرات صناعية",
      },
    },
    about: {
      overline: "عن نخبة الحجاز",
      title: "تميّز هندسي ومقاولات على مستوى المملكة",
      p1: "مؤسسة نخبة الحجاز هي مؤسسة هندسية ومقاولات رائدة مقرها المملكة العربية السعودية، تقدّم حلولاً تقنية متكاملة من البداية إلى النهاية للقطاعين الصناعي والتجاري. ومع أساس قوي قائم على الابتكار والموثوقية والدقة، تقدّم المؤسسة خدمات متكاملة مصممة لتلبية احتياجات المصانع والمنشآت ومشاريع البنية التحتية والمرافق الصناعية واسعة النطاق في جميع أنحاء المملكة.",
      p2: "بأكثر من 15 عامًا من التميّز الهندسي في مختلف مناطق المملكة، أرست نخبة الحجاز سجلاً قويًا من الشراكات على المستويين الكبير والصغير. وتلتزم المؤسسة بالجودة والسلامة ورضا العملاء وتقديم قيمة طويلة الأمد للمشاريع.",
      values: [
        { t: "الابتكار", d: "ممارسات هندسية حديثة وتحسين مستمر في كل موقع." },
        { t: "الموثوقية", d: "تنفيذ منضبط وتسليم في الوقت المحدد وشراكات يُعتمد عليها." },
        { t: "الدقة", d: "تفاوتات ضيقة وضبط جودة وعمل موثّق." },
        { t: "السلامة", d: "ثقافة منع الإصابات والتزام كامل بمعدات الوقاية." },
      ],
    },
    services: {
      overline: "خدماتنا",
      title: "قدرات صناعية متكاملة",
      subtitle:
        "أربعة محاور خدمية رئيسية تغطي دورة حياة المشاريع الصناعية الكاملة — من العقد إلى التشغيل والصيانة.",
      cards: [
        {
          t: "المقاولات الكهروميكانيكية العامة",
          d: "حلول مقاولات كهروميكانيكية متكاملة للمنشآت الصناعية والتجارية تشمل التركيب والتكامل والتشغيل والدعم الفني.",
        },
        {
          t: "تصنيع الحديد وأعمال التركيب الثقيل",
          d: "تصنيع وتركيب احترافي للهياكل الفولاذية الصناعية والصهاريج والصوامع والناقلات والمعدات الثقيلة والمنصات والهياكل الخاصة بالمصانع.",
        },
        {
          t: "أنظمة الأتمتة والتحكم",
          d: "حلول أتمتة صناعية تشمل لوحات التحكم وأنظمة PLC ودعم خطوط الإنتاج ووحدات التعبئة المتنقلة وآلات إغلاق الأكياس وفواصل المعادن المغناطيسية ولوحات التوزيع ولوحات MCC.",
        },
        {
          t: "الصيانة",
          d: "حلول صيانة وإصلاح موثوقة للآلات الصناعية والناقلات والأعمدة والمنافيخ والأحزمة المطاطية وإصلاح الخرسانة وأنظمة الجوانات والمواد الرابطة والمعدات الثقيلة.",
        },
      ],
      capOverline: "القدرات",
      capTitle: "قدرات التصنيع الميكانيكي",
      capSubtitle: "ورشة داخلية كاملة تغطي المعدات الإنشائية والميكانيكية ومعدات العمليات.",
      capItems: [
        "السيكلونات",
        "القمعات",
        "الصهاريج والصوامع",
        "كسارات الفك",
        "الرافعات الدلوية",
        "أعمال ورشة المكائن",
        "هياكل المنصات",
        "أنظمة الخلاط والمحرّكات",
        "شفرات المشتت المزدوج للخلاطات",
        "قطع CNC بالنفث المائي والبلازما",
        "ناقلات الأحزمة",
        "الناقلات الحلزونية",
        "ناقلات السلسلة المعيارية",
        "أنظمة العربات",
        "الشفرات والقاطعات",
        "الطاولات",
        "المراوح والمنافيخ",
        "الأعمدة والمساكن",
        "مجمّعات الغبار",
      ],
    },
    projects: {
      overline: "أعمال مختارة",
      title: "ملف المشاريع الصناعية",
      subtitle: "من التصنيع الميكانيكي إلى التركيب والأتمتة على نطاق واسع — لمحة عن أعمالنا الأخيرة.",
      filters: {
        all: "الكل",
        fabrication: "تصنيع",
        erection: "تركيب",
        automation: "أتمتة",
        maintenance: "صيانة",
      },
      viewDetails: "عرض التفاصيل",
      categories: {
        fabrication: "التصنيع الميكانيكي",
        erection: "أعمال التركيب الثقيل",
        automation: "أنظمة الأتمتة",
        maintenance: "أعمال الصيانة",
        bagging: "تصنيع وحدات التعبئة المتنقلة",
        installation: "تركيب المعدات الصناعية",
      },
      items: [
        { cat: "fabrication", title: "التصنيع الميكانيكي", desc: "تصنيع الصهاريج والصوامع والمنصات والناقلات والهياكل الصناعية بهندسة عالية الدقة." },
        { cat: "erection", title: "أعمال التركيب الثقيل", desc: "دعم تركيب آمن وفعّال للمنشآت الصناعية والهياكل الفولاذية والمعدات الثقيلة." },
        { cat: "automation", title: "أنظمة الأتمتة", desc: "لوحات التحكم ودعم الأتمتة وتكامل آلات الإنتاج وتحسين الأنظمة الصناعية." },
        { cat: "maintenance", title: "الصيانة", desc: "إصلاح وإعادة بناء وحلول التسرب الصناعي وإصلاح الأحزمة المطاطية وإصلاحات شاملة ودعم وقائي." },
        { cat: "fabrication", title: "وحدة تعبئة متنقلة", desc: "تصنيع متكامل لوحدات التعبئة المتنقلة المدمجة مع آلات إغلاق الأكياس." },
        { cat: "automation", title: "لوحات MCC والتوزيع", desc: "لوحات MCC مخصصة ولوحات توزيع ولوحات خطوط إنتاج تعتمد على PLC." },
        { cat: "erection", title: "تركيب الصوامع والصهاريج", desc: "تركيب الصوامع والصهاريج وأوعية العمليات لقطاعات الإسمنت والأغذية والكيماويات." },
        { cat: "maintenance", title: "إصلاح الناقلات", desc: "إعادة بناء أحزمة الناقلات وفلكنة الأحزمة المطاطية ومحاذاة الأعمدة واستبدال المحامل." },
      ],
    },
    clients: {
      overline: "عملاؤنا",
      title: "عملاؤنا الموثوقون",
      subtitle: "نفخر بدعم كبرى العلامات التجارية الصناعية والتجارية.",
      list: [
        "جوتن",
        "بي فارما",
        "عبداللطيف جميل",
        "CEEER",
        "يونيليفر",
        "نسما أوربت",
        "هيلز للأسقف المعدنية",
        "NBCC",
        "آر سي كولا",
        "UCIC",
        "فوزروك",
        "يورو ديزاين بيلد",
      ],
    },
    manpower: {
      overline: "القدرات البشرية",
      title: "قوة الكوادر والسلامة",
      subtitle: "فريق متعدد التخصصات مبني على خبرات الميكانيكا والكهرباء والتصنيع والسلامة.",
      stats: [
        { label: "مهندسون ميكانيكيون", value: 2 },
        { label: "مهندس كهرباء", value: 1 },
        { label: "فنيو تصنيع حديد", value: 4 },
        { label: "لحامون", value: 8 },
        { label: "لحامو MIG", value: 2 },
        { label: "لحامو TIG", value: 3 },
        { label: "ميكانيكيون", value: 6 },
        { label: "رافعو حمولات", value: 10 },
        { label: "فنيو تركيب", value: 8 },
        { label: "عمال", value: 20 },
        { label: "مشرفون", value: 2 },
      ],
      safetyOverline: "السلامة",
      safetyTitle: "السلامة أولاً",
      safetyBody:
        "السلامة قيمة جوهرية في كل مشروع لنخبة الحجاز. تتبع فرقنا معايير السلامة المهنية وتستخدم معدات الوقاية المناسبة وتلتزم بالانضباط في تنفيذ الموقع لحماية العاملين والعملاء وأصول المشروع.",
      safetyChecks: [
        "خطط سلامة خاصة بكل موقع",
        "إلزامية معدات الوقاية: خوذة ونظارات وحزام وقفازات",
        "اجتماعات الأدوات وتوعية يومية للسلامة",
        "نظام تصاريح العمل للأعمال الساخنة والأماكن المغلقة",
        "تقييمات مخاطر موثقة وبيانات طريقة العمل",
      ],
    },
    contact: {
      overline: "تواصل",
      title: "تواصل مع نخبة الحجاز",
      subtitle: "أخبرنا عن مشروعك. سيستجيب فريقنا الهندسي بسرعة.",
      form: {
        name: "الاسم الكامل",
        company: "اسم الشركة",
        email: "البريد الإلكتروني",
        phone: "رقم الجوال",
        service: "الخدمة المطلوبة",
        servicePlaceholder: "اختر خدمة",
        message: "تفاصيل المشروع / الرسالة",
        submit: "إرسال عبر واتساب",
        submitEmail: "إرسال عبر البريد",
        success: "يتم فتح واتساب برسالتك…",
      },
      servicesList: [
        "المقاولات الكهروميكانيكية العامة",
        "تصنيع الحديد والتركيب الثقيل",
        "أنظمة الأتمتة والتحكم",
        "الصيانة الصناعية",
        "أخرى",
      ],
      info: {
        company: "الشركة",
        cr: "السجل التجاري",
        vat: "الرقم الضريبي",
        phone: "هاتف",
        email: "البريد",
        address: "العنوان",
        addressValue: "شارع وادي القائم، حي العزيزية، جدة 23337، المملكة العربية السعودية",
        website: "الموقع الإلكتروني",
      },
      callNow: "اتصل الآن",
      whatsapp: "واتساب",
      emailUs: "البريد",
    },
    footer: {
      tagline: "تميّز هندسي ومقاولات على مستوى المملكة",
      quickLinks: "روابط سريعة",
      services: "الخدمات",
      contact: "تواصل",
      copyright: "© {year} مؤسسة نخبة الحجاز. جميع الحقوق محفوظة.",
    },
    common: {
      loading: "جارٍ التحميل",
      backToTop: "العودة للأعلى",
      learnMore: "اقرأ المزيد",
    },
  },
};
